import React from "react";
import "./EnquirySuccess.css";

const EnquirySuccess = () => {
  const handleHome = () => {
    window.location.href = "/";
  };

  const handleServices = () => {
    window.location.href = "/services";
  };

  return (
    
   <>

   <div className="space80"></div>
   <div className="space80"></div>

    <div className="enquiry-success">
      <div className="success-icon-wrapper">
        
        <div className="success-icon">
          <svg
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="32"
              cy="32"
              r="28"
              stroke="currentColor"
              strokeWidth="5"
            />
            <path
              d="M20 32L28 40L44 23"
              stroke="currentColor"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      <h1>Thank You!</h1>

      <h2>Your Enquiry Has Been Submitted</h2>

      <p>
        We've received your enquiry successfully.
        <br />
        Our executive will review your details and contact you shortly.
      </p>

      <div className="success-actions">
        <button
          type="button"
          className="success-home-btn"
          onClick={handleHome}
        >
          <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            width="18"
            height="18"
            aria-hidden="true"
          >
            <path d="M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z" />
          </svg>
          Back to Home
        </button>

        <button
          type="button"
          className="success-services-btn"
          onClick={handleServices}
        >
          Explore Our Legal Services
          <span aria-hidden="true">→</span>
        </button>
      </div>
    </div>
   
   </>
  );
};

export default EnquirySuccess;